import { render } from "./PushPrompt.vue?vue&type=template&id=4b7f3184&scoped=true"
import script from "./PushPrompt.vue?vue&type=script&lang=js"
export * from "./PushPrompt.vue?vue&type=script&lang=js"

import "./PushPrompt.vue?vue&type=style&index=0&id=4b7f3184&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b7f3184"]])

export default __exports__